import app from '../angular_app.es6';

app.controller('ClientsController', [ '$scope', '$http', '$timeout', 'Notification', ($scope, $http, $timeout, Notification) => {

    $scope.mainClients = []

    $scope.state = {
        loading: false
    }


    $scope.init = () => {
        $scope.loadClients();
    };


    $scope.loadClients = () => {
        $scope.state.loading = true

        $http.get(
            '/express/api/clients',
            { }
        ).then(
            (response) => {
                $scope.mainClients = response.data.clients
            },
            (response) => {

            }
        ).finally(
            () => { $scope.state.loading = false }
        )
    };


    $scope.subCandidates = (current) => {
        return  $scope.mainClients.filter( (el) => { return el.id != current.id && el.subclients.length == 0 } )
    }


    $scope.addSub = (event, main, sub) => {
        event.preventDefault();

        if($scope.state.loading){ return }

        $scope.state.loading = true;

        $http.post(
            `/express/api/clients/${main.id}/add_subclient`,
            { sub_id: sub.id}
        ).then(
            (response) => {
                const index = $scope.mainClients.findIndex((el)=>{return el.id == sub.id})
                const deleted = $scope.mainClients.splice(index, 1)
                main.subclients.push(deleted[0])
                main.subclients = $scope.sortByLowerName( main.subclients )

            },
            (response) => {}
        ).finally(
            () => { $scope.state.loading = false }
        );
    }


    $scope.deleteSub = (main, sub) => {
        if($scope.state.loading){ return }

        $scope.state.loading = true;

        $http.post(
            `/express/api/clients/${main.id}/delete_subclient`,
            {sub_id: sub.id}
        ).then(
            (response) => {
                const index = main.subclients.findIndex((el)=>{return el.id == sub.id})
                const deleted = main.subclients.splice(index, 1)
                deleted[0].subclients = []
                $scope.mainClients.push(deleted[0])
                $scope.mainClients = $scope.sortByLowerName( $scope.mainClients )
            },
            (response) => {}
        ).finally(
            () => { $scope.state.loading = false }
        );
    }


    $scope.addCredits = (client) => {
        if($scope.state.loading){ return }

        $scope.state.loading = true;

        const amount = parseInt(client.tempAmount)

        $http.post(
            `/express/api/clients/${client.id}/add_credits`,
            {amount: amount}
        ).then(
            (response) => {
                client.credits = client.credits + amount
                client.tempAmount = 0
            },
            (response) => {
                Notification.error(response.data.errors.amount)
            }
        ).finally(
            () => { $scope.state.loading = false }
        )
    };


    $scope.removeCredits = (client) => {
        if($scope.state.loading){ return }

        $scope.state.loading = true;

        const amount = parseInt(client.tempAmount)

        $http.post(
            `/express/api/clients/${client.id}/delete_credits`,
            {amount: amount}
        ).then(
            (response) => {
                client.credits = client.credits - amount
                client.tempAmount = 0
            },
            (response) => {
                Notification.error(response.data.errors.amount)
            }
        ).finally(
            () => { $scope.state.loading = false }
        )
    }


    $scope.sortByLowerName = (records) => {
        return records.sort((a,b)=>{
            const n1 = a.name.toLowerCase(), n2 = b.name.toLowerCase()
            return (n1 < n2 ? -1 : ( n1 > n2 ? 1 : 0))
        })
    }


}]);